// extracted by mini-css-extract-plugin
module.exports = {"layout":"theme-bg_layout__j6_2_","bg":"theme-bg_bg__DXNV6","overlay":"theme-bg_overlay___36cU"};